<template>
  <span>

    <crud-layout-search
      ref="crudLayoutSearch"
      :params="params"
      :interface="nmInterface"
      :id="id"
      :row-buttons="true"
      :page="page"
      multiselect
      :name="name"
    >
      <campaign-page-table
        slot="page-table"
        slot-scope="dataPageTable"
        v-bind="dataPageTable"
        @action-button="dataPageTable.actionButton"
        @show-message="dataPageTable.showMessage"
      />
    </crud-layout-search>

    <campaign-detail-modal
      ref="campaignDetailModal"
      :show.sync="showDetailModal"
      @edit="openEditModal"
    />

    <campaign-edit-modal
      ref="campaignModal"
      :show.sync="showCampaignModal"
      @campaign-saved="onCampaignSaved"
    />

  </span>
</template>
<script>
import CampaignPageTable from './CampaignPageTable.vue'
import CampaignEditModal from './CampaignEditModal.vue'
import CampaignDetailModal from './CampaignDetailModal.vue'
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { messageBox, repository } from 'jtech'

const { page, pageTable, CrudLayoutSearch } = JtCrud

const CAMPAIGN_ACTIVATE_INTERFACE = 'campaign.activate'
const CAMPAIGN_PAUSE_INTERFACE = 'campaign.pause'
const CAMPAIGN_DISPATCH_INTERFACE = 'campaign.dispatch'
@Component({
  mixins: [page],
  name: 'MsgCampaign',
  components: {
    CrudLayoutSearch,
    CampaignPageTable,
    CampaignDetailModal,
    CampaignEditModal
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class MsgCampaign extends Vue {
  showCampaignModal = false
  showDetailModal = false

  get nmInterface () {
    return this.interface
  }

  get page () {
    return page
  }

  async mounted () {
    await this.$nextTick()
    this.$refs.crudLayoutSearch.onButton('btNovo', () => this.openCreateModal())
    this.$refs.crudLayoutSearch.onButton('icAlterar', (button, params) => this.openEditModal(button, params))
    this.$refs.crudLayoutSearch.onButton('icDetalhar', (button, params) => this.openDetailById(button, params))
    this.$refs.crudLayoutSearch.onButton('ativar', (button, params) => this.handleAtivar(button, params))
    this.$refs.crudLayoutSearch.onButton('pausar', (button, params) => this.handlePausar(button, params))
    this.$refs.crudLayoutSearch.onButton('disparar', (button, params) => this.handleDisparar(button, params))
  }

  openCreateModal () {
    this.$refs.campaignModal.openCreate()
  }

  openDetailById (button, params) {
    const row = params || button?.params || button || {}
    const id = row.id || row.campaign || row.campaignId
    if (!id) return
    this.$refs.campaignDetailModal.openDetail(id)
  }

  openDetailModal (campaignData) {
    this.selectedCampaign = campaignData
    this.showDetailModal = true
  }

  async openEditModal (button, params) {
    const campaignData = params || button?.params || button || {}
    await new Promise(resolve => setTimeout(resolve, 300))

    const id = campaignData.id || campaignData.campaignId || campaignData.campaign
    if (!id) return
    this.$refs.campaignModal.openEdit(id)
  }

  onCampaignSaved () {
    this.$refs.crudLayoutSearch?.refresh?.()
  }

  async handleAtivar (button, params) {
    try {
      const campaignData = params || button?.params || button || {}
      const id = campaignData.id || campaignData.campaignId || campaignData.campaign
      if (!id) return

      await repository.resolveLogic(CAMPAIGN_ACTIVATE_INTERFACE, { id })
      this.$refs.crudLayoutSearch?.refresh?.()
    } catch (error) {
      console.error('Erro ao ativar campanha:', error)
    }
  }

  async handlePausar (button, params) {
    try {
      const campaignData = params || button?.params || button || {}
      const id = campaignData.id || campaignData.campaignId || campaignData.campaign
      if (!id) return

      await repository.resolveLogic(CAMPAIGN_PAUSE_INTERFACE, { id })
      this.$refs.crudLayoutSearch?.refresh?.()
    } catch (error) {
      console.error('Erro ao pausar campanha:', error)
    }
  }

  async handleDisparar (button, params) {
    try {
      const campaignData = params || button?.params || button || {}
      const id = campaignData.id || campaignData.campaignId || campaignData.campaign
      if (!id) return

      const response = await repository.resolveLogic(CAMPAIGN_DISPATCH_INTERFACE, { id })
      const dispatchSize = Number(response?.dispatchSize ?? 0)
      const isSuccess = response?.result === 'success'

      this.$refs.crudLayoutSearch?.refresh?.()

      if (isSuccess) {
        if (dispatchSize === 0) {
          messageBox.warn(this.$gettext('NONE') + ' ' + this.$gettext('MESSAGE_SENT'), 'top-right')
        } else {
          const message = dispatchSize === 1 ? this.$gettext('MESSAGE_SENT') : dispatchSize + ' ' + this.$gettext('MESSAGES_SENT')
          messageBox.success(message, 'top-right')
        }
      }
    } catch (error) {
      console.error('Erro ao disparar campanha:', error)
    }
  }
}
export default MsgCampaign
</script>
